import { http } from '../axios';

export default {
  namespaced: true,
  actions: {
    async canDoAction(_, { action }) {
      try {
        const { data } = await http.get('/api/helper/can-use', { params: { action } });
        return data;
      } catch {
        return {};
      }
    },
  },
};
